import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../enTranslations';
import amTranslations from '../arTranslation';

i18n
  .use(initReactI18next)  // Hook into React for i18n support
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      amh: {
        translation: amTranslations,
      },
    },
    lng: "en", // default language
    fallbackLng: "en", // fallback language if translation for a key is not found
    interpolation: {
      escapeValue: false, // react already does escaping
    },
  });

export default i18n;  // Exp